import ButtonClose from '@components/button-close/ButtonClose';
import ButtonCommon from '@components/button-common/ButtonCommon';
import Portal from '@components/portal/Portal';
import { handleOpenModelError, modelErrorSelector } from '@lib/store/slices/ComponentsSlice';
import { useDispatch, useSelector } from 'react-redux';

import style from './ModalError.module.scss';

function ModalError() {
  const openModelError = useSelector(modelErrorSelector);
  const dispatch = useDispatch();

  const handleCloseModelError = () => {
    dispatch(handleOpenModelError(false));
  };
  return (
    <>
      {openModelError && (
        <Portal>
          <div className={style.modalErrorContainer}>
            <div className={style.modalErrorBack} />
            <div className={style.modalErrorBox}>
              <ButtonClose className={style.modalErrorBtn} handleFuction={handleCloseModelError} id='close_black' />
              <div className={style.modalErrorTitle}>Ошибка</div>
              <div className={style.modalErrorText}>
                Сервер временно недоступен, пожалуйста, повторите запрос позже.
              </div>
              <ButtonCommon className={style.modalErrorBtnClose} handleFuction={handleCloseModelError} text='Закрыть' />
            </div>
          </div>
        </Portal>
      )}
    </>
  );
}

export default ModalError;
